import { ConfirmationFormulaire } from '@components/confirmation-formulaire/models';
import { Block } from '@shared/models';

export const confirmationFormulaireMock: Block<ConfirmationFormulaire> = {
  type: 'confirmation-formulaire',
  data: {
    message: 'Votre message a bien été transmis à nos équipes, nous vous répondrons dans les plus brefs délais',
  },
};
